import React from 'react'
import PropTypes from 'prop-types'
import { Container } from './styles'
import CreateIcon from '../../buttons/add-button/create-icon/CreateIcon'

const AddButton = ({ onClick, label, disabled, className }) => {
    return (
        <Container
            className={className}
            onClick={() => {
                !disabled && onClick()
            }}
        >
            <CreateIcon disabled={disabled} className={`material-icons ${className}`} id="id" label={label} />
        </Container>
    )
}

AddButton.propTypes = {
    onClick: PropTypes.func,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    id: PropTypes.string,
}

export default AddButton
